import type { RowAction } from '@/components/ui/data-table/types';
import { listMutations } from '@/features/lists/lists.queries';
import { executeMutation } from '@/utils/executeMutation';
import type { ListSummary } from '@certhon/models';
import { Trash2 } from 'lucide-react';

export { adaptActionsForPanel } from '@/utils/adaptActionsForPanel';

/**
 * Template-specific row/panel actions.
 */
export function getTemplateActions(
  _userId: number | null,
): RowAction<ListSummary>[] {
  return [
    {
      id: 'delete',
      icon: Trash2,
      label: 'Delete',
      variant: 'destructive',
      onCalled: async (template) => {
        executeMutation(listMutations.delete(), template.id);
      },
    },
  ];
}
